import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_urgency_message';
const urgencyMessageQuery = `
    query UnitMessage($unitUuid: String!, $dateRange: UrgencyDateRange, $assetVersion: Int!) {
        unitMessage(unitUuid: $unitUuid, dateRange: $dateRange, assetVersion: $assetVersion) {
            iconText {
                message
                icon
                messageValueType
            }
        }
    }
`;

async function urgencyMessageGraphQl({unitUuid, startDate, endDate, assetVersion, locale}) {
    let params = {unitUuid, assetVersion};

    if (startDate && endDate) {
        params.dateRange = {startDate, endDate};
    }

    const mutatedResponse = await graphqlQuery(OPERATION_NAME, urgencyMessageQuery, params, locale);

    return ((mutatedResponse || {}).unitMessage || {}).iconText;
}

export default urgencyMessageGraphQl;
export {urgencyMessageGraphQl, OPERATION_NAME, urgencyMessageQuery};
